<div class="container">
  <div class="cardBox " *ngIf="popupName!=='addLoc'">
    <div class="cardBoxHeading font_medium fs-14">

      <ion-row>
        <ion-col size="4">
          <div class="formLabelSemiBoldfs16 mb-5"> Add Department </div>
        </ion-col>
        <ion-col size="8" class="text-right">
          <img (click)="closepopup()" class="cp" src="././assets/icon/close_icon.png">
        </ion-col>
      </ion-row>
    </div>
    <div class="p-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>Department<span class="red-cl">&nbsp;*</span></th>
                  <th>Department Code<span class="red-cl">&nbsp;*</span></th>
                
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of CombineDeptArray; let i = index">
                  <td>{{item.department}}</td>
                  <td>
                    <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
                      <input matInput [(ngModel)]="item.deptCode"(ngModelChange)="addDeptCode(item)"  placeholder="Type here..." class="font_regular"  [disabled]="editableIndex!==i">
                    </mat-form-field>
                  </td>
                
                  <td>
                    <div class="d-flex" >
                      <img (click)="onClickEdit(i)" *ngIf="( editableIndex !== i||!onCheckIconView)" class="ml-5 cp imgEdit"
                        title="Edit" src="././assets/icon/edit.png">
                      <span (click)="onClickClose()" *ngIf="editableIndex === i && onCheckIconView"
                        class="material-icons close p-10 cp fs-20">close</span>
                      <!-- Single condition for reimbursementAddId check -->
                      <span *ngIf="editableIndex === i && onCheckIconView" (click)="saveBand(i)" class="material-icons link p-10 cp fs-20">
                        check
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
  <div class="cardBox " *ngIf="popupName=='addLoc'">
    <div class="cardBoxHeading font_medium fs-14">

      <ion-row>
        <ion-col size="4">
          <div class="formLabelSemiBoldfs16 mb-5"> Add Location </div>
        </ion-col>
        <ion-col size="8" class="text-right">
          <img (click)="closeLocation()" class="cp" src="././assets/icon/close_icon.png">
        </ion-col>
      </ion-row>
    </div>
    <div class="p-10">
      <ion-row>
       
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container scrollable-table">
            <table>
              <thead>
                <tr>
                  <th>Location<span class="red-cl">&nbsp;*</span></th>
                  <th>Location Code<span class="red-cl">&nbsp;*</span></th>
             
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of updatetableDataForLoca;let i=index">
                  <td>{{item.name}}</td>
                  <td>
                    <mat-form-field class="custom-input w-100 mat-height40 mat-input-style">
                      <input matInput [(ngModel)]="item.code" (ngModelChange)="addDeptCode(item)"  placeholder="Type here..." class="font_regular" [disabled]="editableIndex!==i">
                    </mat-form-field>
                  </td>
                 
                  <td>
                    <div class="d-flex">
                      <img (click)="onClickEdit(i)"  *ngIf="( editableIndex !== i||!onCheckIconView)"  class="ml-5 cp imgEdit"
                        title="Edit" src="././assets/icon/edit.png">
                      <span (click)="onClickCloseLocation()"  *ngIf="editableIndex === i && onCheckIconView"
                        class="material-icons close p-10 cp fs-20">close</span>
                      <!-- Single condition for reimbursementAddId check -->
                      <span *ngIf="editableIndex === i && onCheckIconView" (click)="item.locationId ? updateLocation() : saveLocation()"

                      class="material-icons link p-10 cp fs-20">
                        check
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>
